import fossilImg1 from '@/assets/img/content7/category1/fossilImg1.jpg'
import fossilImg2 from '@/assets/img/content7/category1/fossilImg2.jpg'
import fossilImg3 from '@/assets/img/content7/category1/fossilImg3.jpg'
import fossilImg4 from '@/assets/img/content7/category1/fossilImg4.jpg'

import fossil2Img1 from '@/assets/img/content7/category2/fossil2Img1.jpg'
import fossil2Img2 from '@/assets/img/content7/category2/fossil2Img2.jpg'
import fossil2Img3 from '@/assets/img/content7/category2/fossil2Img3.jpg'
import fossil2Img4 from '@/assets/img/content7/category2/fossil2Img4.jpg'

import fossil3Img1 from '@/assets/img/content7/category3/fossil3Img1.jpg'
import fossil3Img2 from '@/assets/img/content7/category3/fossil3Img2.jpg'

import fossil4Img1 from '@/assets/img/content7/category4/fossil4Img1.jpg'
// import fossil4Img2 from '@/assets/img/content7/category4/fossil4Img2.jpg'
// import fossil4Img3 from '@/assets/img/content7/category4/fossil4Img3.jpg'
import fossil4Img4 from '@/assets/img/content7/category4/fossil4Img4.jpg'

import fossil5Img1 from '@/assets/img/content7/category5/fossil5Img1.jpg'
import fossil5Img2 from '@/assets/img/content7/category5/fossil5Img2.jpg'
import fossil5Img3 from '@/assets/img/content7/category5/fossil5Img3.jpg'


export const btnList = [
  {
    id: 1,
    cnTitle: '丰宁原羽鸟',
    enTitle: '<em>Protopteryx fengningensis</em>',
  },
  {
    id: 2,
    cnTitle: '华夏鸟科',
    enTitle: 'Cathayornithidae',
  },
  {
    id: 3,
    cnTitle: '长翼鸟',
    enTitle: '<em>Longipteryx</em>',
  },
  {
    id: 4,
    cnTitle: '鹏鸟科',
    enTitle: 'Pengornithidae',
  },
  {
    id: 5,
    cnTitle: '其他反鸟类',
    enTitle: 'Other Enantiornithines',
  },
]


export const fengningensisList = [ // 丰宁原羽鸟展示化石
  {
    id: 1,
    src: fossilImg3,
    title: '化石：丰宁原羽鸟 雄',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossilImg4,
    title: '化石：丰宁原羽鸟 雌',
    enTitle: '',
    details: '',
  },
  {
    id: 3,
    src: fossilImg1,
    title: '现代鸟：极乐鸟',
    enTitle: '<em>Paradisaea</em> sp.',
    details: '',
  },
  {
    id: 4,
    src: fossilImg2,
    title: '现代鸟：红嘴蓝鹊',
    enTitle: '<em>Urocissa erythrorhyncha</em>（Boddaert, 1783）',
    details: '',
  },
]

export const fengningensisAnimal = {
  animalType: '丰宁原羽鸟', // 动物类别
  animalTypeEn: '<em>Protopteryx fengningensis</em>  Zhang and Zhou,2000', // 动物类别英文名字
  categoryInfoImg: '',
  categoryTxt: '原羽鸟属于最原始的反鸟类，是热河生物群的典型分子。原羽鸟体型小，上下颌长有牙齿；足部发育有一对强壮有力、适于抓握的趾爪；翅膀长而尖细；蓬松的绒羽覆盖全身并具有一对装饰用的长尾羽。它们已经非常适应在丛林环境生活，并可能以昆虫为食。', // 动物文字介绍
  showList: fengningensisList,
}


export const cathayornithidaeList = [ // 
  {
    id: 1,
    src: fossil2Img3,
    title: '化石：华夏鸟科',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossil2Img4,
    title: '化石：华夏鸟科',
    enTitle: '',
    details: '',
  },
  {
    id: 3,
    src: fossil2Img1,
    title: '现代鸟：蓝翡翠',
    enTitle: '<em>Halcyon pileata</em>（Boddaert, 1783）',
    details: '',
  },
  {
    id: 4,
    src: fossil2Img2,
    title: '现代鸟：黑枕黄鹂',
    enTitle: '<em>Oriolus chinensis</em> Linnaeus, 1766',
    details: '',
  },
]

export const cathayornithidaeAnimal = {
  animalType: '华夏鸟科', // 动物类别
  animalTypeEn: 'Cathayornithidae', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '华夏鸟科鸟类个体小，头部骨骼很少愈合，头颅较大，喙较长而低，具牙齿，指爪仅有两个且不发育，趾爪也不太钩曲。华夏鸟类体型和特征比较类似于现代的鸦科鸟类和翠鸟类。', // 动物文字介绍
  showList: cathayornithidaeList,
}



export const longipteryxList = [ // 长翼鸟化石
  {
    id: 1,
    src: fossil3Img2,
    title: '化石：长翼鸟',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossil3Img1,
    title: '现代鸟：斑头秋沙鸭',
    enTitle: '<em>Mergellus albellus</em>（Linnaeus, 1758）',
    details: '',
  },
]

export const longipteryxAnimal = {
  animalType: '长翼鸟', // 动物类别
  animalTypeEn: '<em>Longipteryx</em>', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '长翼鸟类胸廓稳固、双翼发达、飞行能力较强，嘴长，适应水中捕食，后肢拇趾与其它3趾对握，适宜树栖。它是生活在水边的反鸟类，嘴吻很长，另外嘴里还有很密集的牙齿，吻端发育有几颗向内弯曲、末端尖细的牙齿，发育有类似于鱼叉的锯齿状褶皱边缘，其吻端很像秋沙鸭锯齿状的喙嘴，最善于捕捉光滑的鱼。', // 动物文字介绍
  showList: longipteryxList,
}


export const pengornithidaeList = [ // 四、	鹏鸟科
  // {
  //   id: 1,
  //   src: fossil4Img3,
  //   title: '化石：侯氏鹏鸟',
  //   enTitle: '',
  //   details: '',
  // },
  // {
  //   id: 2,
  //   src: fossil4Img2,
  //   title: '化石：侯氏鹏鸟',
  //   enTitle: '',
  //   details: '',
  // },
  {
    id: 4,
    src: fossil4Img4,
    title: '化石：侯氏鹏鸟',
    enTitle: '',
    details: '',
  },
  {
    id: 3,
    src: fossil4Img1,
    title: '现代鸟：红腹锦鸡',
    enTitle: '<em>Chrysolophus pictus</em>（Linnaeus, 1758）',
    details: '',
  },
]

export const pengornithidaeAnimal = {
  animalType: '鹏鸟科', // 动物类别
  animalTypeEn: 'Pengornithidae', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '侯氏鹏鸟（<em>Pengornis houi</em>）是热河生物群中已知体型最大的反鸟类，牙齿低矮、齿冠呈圆顶状，似乎适合咬破相对坚硬的食物。其形态和特征与现代的雉类较为相似。', // 动物文字介绍
  showList: pengornithidaeList,
}



export const otherList = [ // 其他反鸟类
  {
    id: 1,
    src: fossil5Img3,
    title: '化石：反鸟类未定属种',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossil5Img1,
    title: '现代鸟：小太平鸟',
    enTitle: 'Bombycilla japonica Linnaeus, 1758',
    details: '',
  },
  {
    id: 3,
    src: fossil5Img2,
    title: '现代鸟：紫翅椋鸟',
    enTitle: '<em>Sturnus vulgaris</em>（Linnaeus, 1758）',
    details: '',
  },
]

export const otherAnimal = {
  animalType: '其他反鸟类', // 动物类别
  animalTypeEn: 'Other Enantiornithines', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '一些反鸟类具有和其他脚趾相对而生加的长拇趾，末端趾节长有巨大的爪子，这种适于树栖的脚趾结构类似于现生鸣禽类和其他生活在灌木丛林的鸟类。', // 动物文字介绍
  showList: otherList,
}